
const InvestmentContent = ({ realizedSummery, totalAEDBalance }) => {
    console.log("🚀 ~ InvestmentContent ~ realizedSummery:", realizedSummery)

    const headerStyle = {
        backgroundColor: '#004080',
        color: '#fff',
        fontSize: '13px',
        fontFamily: 'Roboto Regular',
        fontWeight: "normal",
        borderRight: '1px solid rgb(255 255 255 / 50%)',
        verticalAlign: 'middle',
        textAlign: "center",
        padding: "4px 5px"
    };

    const tdStyle = {
        background: '#e0e0e0',
        borderBottom: '1px solid #fff',
        borderRight: '1px solid rgb(255 255 255 / 50%)',
        padding: "4px 5px",
        color: "#000",
        fontSize: '13px',



    }
    const totalTd = {
        fontFamily: "Roboto Black",
        borderTop: '1px solid #000',
        borderBottom: '1px solid #000',
        // padding:"1px",
        fontSize: "13px"
    }
    const total = {
        fontFamily: "Roboto Black",
        fontSize: "13px"
    }
    const avoidPageBreak = {
        pageBreakInside: "avoid",
        breakInside: "avoid-column" // For browsers that support the modern "break-*"
    };
    return (
        <div className="row m-0">
            <div className="col-md-8 mx-auto">
                <div className=" ">
                    <table className="table">
                        <thead>
                            <tr>
                                <th style={{ ...headerStyle }}>Exchange Desc</th>
                                <th style={{ ...headerStyle }}>Currency Desc</th>
                                <th style={{ ...headerStyle }}>Realized G/L (Tran Curr)</th>
                                <th style={{ ...headerStyle }}>Realized G/L (AED)</th>
                                {/* <th style={{ ...headerStyle }}>Available Balance</th>
                                <th style={{ ...headerStyle }}>FX Rate</th>
                                <th style={{ ...headerStyle }}>Balance (AED)</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            <>
                                {realizedSummery.map((item, index) => (
                                    <tr key={index}>
                                        <td style={{ ...tdStyle, fontSize: "12px" }}>{item?.exchange_Desc}</td>
                                        <td style={{ ...tdStyle, fontSize: "12px" }}>{item?.currency_Desc}</td>
                                        <td className="text-end" style={tdStyle}>
                                            <span style={{ color: Number(item.Realized_GL_Tran_Curr) < 0 ? '#E43740' : 'black' }}>
                                                {Number(item.Realized_GL_Tran_Curr) < 0
                                                    ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(item.Realized_GL_Tran_Curr)) || 0)})`
                                                    : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(item.Realized_GL_Tran_Curr) || 0)}
                                            </span>
                                        </td>

                                        <td className="text-end" style={tdStyle}>
                                            <span style={{ color: Number(item.Realized_GL_AED) < 0 ? '#E43740' : 'black' }}>
                                                {Number(item.Realized_GL_AED) < 0
                                                    ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(item.Realized_GL_AED)) || 0)})`
                                                    : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(item.Realized_GL_AED) || 0)}
                                            </span>
                                        </td>
                                        {/* <td className="text-end" style={tdStyle}>
                                                <span style={{ color: Number(item.CFDLossBlocked) < 0 ? '#E43740' : 'black' }}>
                                                    {Number(item.CFDLossBlocked) < 0
                                                        ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(item.CFDLossBlocked)) || 0)})`
                                                        : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(item.CFDLossBlocked) || 0)}
                                                </span>
                                            </td>
                                            <td className="text-end" style={tdStyle}>
                                                <span style={{ color: Number(item.AvailableBalance) < 0 ? '#E43740' : 'black' }}>
                                                    {Number(item.AvailableBalance) < 0
                                                        ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(item.AvailableBalance)) || 0)})`
                                                        : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(item.AvailableBalance) || 0)}
                                                </span>
                                            </td>

                                            <td className="text-end" style={tdStyle}>
                                                <span style={{ color: Number(item.FXRate) < 0 ? '#E43740' : 'black' }}>
                                                    {Number(item.FXRate) < 0
                                                        ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(item.FXRate)) || 0)})`
                                                        : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(item.FXRate) || 0)}
                                                </span>
                                            </td>
                                            <td className="text-end" style={tdStyle}>
                                                <span style={{ color: Number(item.BalanceInAED) < 0 ? '#E43740' : 'black' }}>
                                                    {Number(item.BalanceInAED) < 0
                                                        ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(item.BalanceInAED)) || 0)})`
                                                        : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(item.BalanceInAED) || 0)}
                                                </span>
                                            </td> */}
                                    </tr>
                                ))}
                            </>
                        </tbody>
                        <tfoot>
                            <tr>

                                {/* <td className="border-0"></td> */}
                                {/* <td className="border-0"></td>
                                <td className="border-0"></td> */}
                                <td className="border-0"></td>
                                <td className="border-0"></td>
                                <td className="text-end border-0" style={total}>Total</td>
                                <td
                                    className="text-end border-0 p-0"

                                >
                                    <div style={totalTd}>
                                        <span style={{ color: Number(totalAEDBalance) < 0 ? '#E43740' : 'black' }}>
                                            {Number(totalAEDBalance) < 0
                                                ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(totalAEDBalance)) || 0)})`
                                                : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(totalAEDBalance) || 0)}
                                        </span>
                                    </div>

                                </td>

                            </tr>
                        </tfoot>
                    </table>

                </div>
            </div>

        </div>)
}
export default InvestmentContent